if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"login","remotes":[{"alias":"core","name":"core","entry":"https://core.stage.mancity.com/_next/static/chunks/remoteEntry.js","shareScope":"default","externalType":"script"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^((148|571|692)1|(3|86)20|1697|4847|7343|9166)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {"core":[{"alias":"core","name":"core","entry":"https://core.stage.mancity.com/_next/static/chunks/remoteEntry.js","shareScope":"default","externalType":"script"}]}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}